import IconUneditable from "../../assets/icon-uneditable.svg";
import InformationIcon from "../icons/InformationIcon";

interface Props {
  label?: string;
  required?: boolean;
  uneditable?: boolean;
  noInfo?: boolean;
}

const InputLabel = ({ label, required, uneditable, noInfo }: Props) => {
  return (
    <div className="flex items-center gap-2 font-bold">
      <div className="mb-1 me-1 flex items-center gap-[2px]">
        {!noInfo && noInfo === false && <InformationIcon />}
        <span>{label}</span>
      </div>
      {required && !uneditable && (
        <div className="h-2 w-2 rounded-full bg-[red]" />
      )}
      {uneditable && (
        <img
          className="h-[16px] w-[16px]"
          src={IconUneditable}
          alt="icon uneditable"
        />
      )}
    </div>
  );
};

export default InputLabel;
